import { render, staticRenderFns } from "./ProductKardex.vue?vue&type=template&id=51dd9278&scoped=true"
import script from "./ProductKardex.vue?vue&type=script&lang=js"
export * from "./ProductKardex.vue?vue&type=script&lang=js"
import style0 from "./ProductKardex.vue?vue&type=style&index=0&id=51dd9278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dd9278",
  null
  
)

export default component.exports